import React from 'react';

const MailIcon = ({ width = 24, height = 24, fill = '#656263' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22 4H2V20H22V4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill={fill} />
    </svg>
  );
};

export default MailIcon;
